import './item-edit-screen-header.scss'

import { defineComponent, PropType } from 'vue'

import { Wemi } from '@skinsoft/types'
import { itemSelectors, manifestationSelectors, workSelectors } from '@skinsoft/selectors'
import * as _ from 'lodash'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { Author } from '@skinsoft/ui/src/item-card/description/author'
import { Media } from '@skinsoft/ui/src/item-card/media'
import { ThesaurusTermView } from '@skinsoft/ui'

export const ItemEditScreenHeader = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sAuthor: Author,
        sMedia: Media,
        sThesaurusTermView: ThesaurusTermView,
    },
    props: {
        entity: {
            type: Object as PropType<Wemi>,
        },
        actionsAvailable: {
            type: Boolean,
            default: false,
        },
    },
    template: require('./item-edit-screen-header.html'),
    computed: {
        mediaId() {
            if(this.entity?.item) {
                return itemSelectors.media(this.entity?.item)
            }
            return ""
        },

        title() {
            if (this.entity?.work) {
                return workSelectors.title(this.entity.work, this.getAppLocale())
            }
        },

        inventoryNumber() {
            if(this.entity?.item) {
                return itemSelectors.identifier(this.entity?.item, this.getAppLocale())
            }
            return ""
        },

        authorId() {
            if (this.entity?.work) {
                return workSelectors.credits(this.entity.work).alias
            }
        },

        domain() {
            if (this.entity?.manifestation && !_.isEmpty(manifestationSelectors.domain(this.entity.manifestation))) {
                return manifestationSelectors.domain(this.entity.manifestation)
            }
        },

        denomination() {
            if (this.entity?.manifestation && !_.isEmpty(manifestationSelectors.name(this.entity.manifestation))) {
                return manifestationSelectors.name(this.entity.manifestation)
            }
        },

        isOfflineItem() {
            return !window.navigator.onLine || !!this.entity?.item?.id?.startsWith('_')
        },
    },
})
